var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ invisible: !_vm.showTable }},[_vm._m(0),_c('BBDataTable',{ref:"artRequestTable",staticClass:"artRequest",attrs:{"columns":_vm.columns,"support-add-new":false,"path-url-api":"designs","load-items-fn":_vm.onItemsLoaded,"default-api-params":{
      _fields:
        'statuses,createdAt,note,currentStatus.name,currentStatus.status,artRequest',
      _sort: 'createdAt',
      _order: 'desc',
      _fieldsNoPopulate: 'name,_id',
      _filter: [
        {
          field: 'isDeleted',
          op: '=',
          val: 'false'
        },
        {
          field: 'artRequest.reviewByUser',
          op: '!=',
          val: 'true'
        },
        {
          field: 'user',
          op: '=',
          val: _vm.userId
        },
        {
          field: 'currentStatus',
          op: '=',
          op: 'in',
          val: [
            this.designStatusArtApproved,
            this.designStatusArtReturned,
            this.designStatusArtPendingMod,
            this.designStatusArtCompleteMod,
            this.designStatusArtRequest
          ]
        }
      ]
    }},scopedSlots:_vm._u([{key:"customCell",fn:function(ref){
    var props = ref.props;
return [(props.column.field == 'note')?_c('div',{staticClass:"limitNote"},[_vm._v("\n        "+_vm._s(_vm.getNoteDesign(props.row))+"\n      ")]):_vm._e(),(props.column.field == 'attachments')?_c('div',{staticClass:"fileWidth"},_vm._l((_vm.getAttachmentsDesign(props.row)),function(file){return _c('span',{key:file._id},[_c('font-awesome-icon',{staticClass:"mr-2 fileIcon",attrs:{"id":file._id,"icon":_vm.icons.file},on:{"click":function($event){return _vm.onOpeningUploadedAttachment(file.link)}}}),_c('b-tooltip',{attrs:{"target":file._id,"triggers":"hover","placement":"right"}},[_vm._v("\n            "+_vm._s(file.filename)+"\n          ")])],1)}),0):(props.column.field == 'currentStatus')?_c('div',{staticClass:"currentStatusCell "},[([2, 4, 5].includes(props.row.currentStatus.status))?_c('div',{staticClass:"statusCell"},[_vm._v("\n          In Progress\n        ")]):([3, 6].includes(props.row.currentStatus.status))?_c('div',{staticClass:"statusCell blueGround"},[_vm._v("\n          Please Review\n        ")]):_vm._e()]):_vm._e()]}},{key:"customButtons",fn:function(slotProps){return [(slotProps.props.row)?_c('div',{staticClass:"btn btn-link btn-highlight btn-sm d-flex align-items-center ml-1",on:{"click":function($event){return _vm.redirectReview(slotProps.props.row)}}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":_vm.icons.eyeIcon}}),_c('span',{staticClass:"bb-label"},[_vm._v("REVIEW")])],1):_vm._e()]}}])})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("Art Requests")])])}]

export { render, staticRenderFns }